<template>
  <section
    class="content"
    v-permission.if="[USER_ROLES.ADMIN,USER_ROLES.SUPER_ADMIN,USER_ROLES.GA_HEAD, USER_ROLES.JOURNEY_MANAGER,USER_ROLES.REPORT_STAFF]"
  >
    <div>
      <div class="box-body">
        <div
          :class="addButtonClass"
          v-permission.if="[USER_ROLES.ADMIN,USER_ROLES.SUPER_ADMIN,USER_ROLES.GA_HEAD]"
        >
        </div>
        <v-server-table
          ref="schedulesExpiryTable"
          url
          :columns="columns"
          :options="options"
          v-on:row-click="edit"
          @loaded="onLoaded"
        >
          <template slot="beforeBody">
            <tr v-if="loading" class="VueTables__no-results">
              <td class="text-center" colspan="6">
                <pulse-loader></pulse-loader>
              </td>
            </tr>
          </template>
        </v-server-table>
      </div>
    </div>
  </section>
</template>

<script>
import { USER_ROLES } from '../../../config';
import { Event } from 'vue-tables-2';

import moment from 'moment';
export default {
    name: 'SchedulesExpiry',
    data() {
        return {
            USER_ROLES: USER_ROLES,
            loading: null,
            schedulesExpiryTable: null,
            columns: [
                'reportType',
                'reportFrequency',
                'scheduleStartDate',
                'scheduleEndDate',
                'status',
            ],
            options: {
                highlightMatches: true,
                sortable: [
                    'reportType',
                    'reportFrequency',
                    'scheduleStartDate',
                    'scheduleEndDate',
                    'status',
                ],

                headings: {
                    reportType: 'Report Type',
                    reportFrequency: 'Schedule Type',
                    scheduleStartDate: 'Schedule Start Date',
                    scheduleEndDate: 'Schedule End Date',
                    status: 'Status',
                },
                templates: {
                    scheduleStartDate(row, query) {
                        return moment(query.scheduleStartDate).format('DD-MM-YYYY');
                    },
                    scheduleEndDate(row, query) {
                        return moment(query.scheduleEndDate).format('DD-MM-YYYY');
                    },
                    status(row, query) {
                        return query.status[0].toUpperCase() + query.status.slice(1);
                    },     
                },

                requestFunction: request => {
                    const params = {};
                    params.$page = request.page;
                    params.$limit = request.limit;
                    this.loading = true;
                    return this.$reportScheduleReminderDataRepository
                    .list(params)
                    .catch(error => {
                        console.error('Report.requestFunction-error:', error);
                        this.$snotify.error(
                        'Get Report Schedule History failed',
                        'Error!',
                        );
                    });
                },
                responseAdapter: response => {
                    this.loading = false;
                    console.log("response",response)
                    console.log("end date ",response.data.docs.scheduleEndDate)
                    let endDate = new Date(response.data.docs.scheduleEndDate)
                    return {
                        data: response.data.docs,
                        count: response.data.docs.length,
                    };
                },
                uniqueKey: '_id',  
            }
        }
    },
    computed: {
        addButtonClass() {
            if (this.schedulesExpiryTable) {
                return this.schedulesExpiryTable.count > this.schedulesExpiryTable.limit ||
                this.schedulesExpiryTable.limit > 10
                ? 'shift-add-left'
                : 'add-item';
            } else {
                return 'add-item';
            }
        },
    },
    methods: {
        edit(data) {
            this.$router.push({
                name: 'ReportScheduleDetails',
                params: { _id: data.row._id },
                props: data.row,
            });
        },
        onLoaded() {
            this.schedulesExpiryTable = this.$refs.schedulesExpiryTable;
        },
    }
}

</script>

<style scoped>

.box-body {
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)
}
</style>



// WEBPACK FOOTER //
// SchedulesExpiry.vue?3c5da7da